import PropTypes from 'prop-types';

import { RadioGroup } from 'shared';
import { Flex } from 'shared_DEPRECATED/components/Flex';
import { dateUtils } from 'shared_DEPRECATED/utils';

import { ChallengeFrequencyDialogCustomWeeklyField } from 'features/challenge/components/FrequencyDialog/CustomWeeklyField';
import { ChallengeFrequencyDialogNumberWeeklyField } from 'features/challenge/components/FrequencyDialog/NumberWeeklyField';
import { ChallengeFrequencyDialogWeekdayField } from 'features/challenge/components/FrequencyDialog/WeekdayField';
import {
  TARGET_TYPES,
  WEEKDAY_TARGET_DEFAULT,
} from 'features/challenge/config';

const frequencyPropType = PropTypes.shape({
  dueDate: PropTypes.string,
  type: PropTypes.string.isRequired,
  weekday: PropTypes.shape({
    fri: PropTypes.bool.isRequired,
    mon: PropTypes.bool.isRequired,
    sat: PropTypes.bool.isRequired,
    sun: PropTypes.bool.isRequired,
    thu: PropTypes.bool.isRequired,
    tue: PropTypes.bool.isRequired,
    wed: PropTypes.bool.isRequired,
  }).isRequired,
  weekly: PropTypes.arrayOf(PropTypes.number),
});

const FrequencyDialogBodyPropTypes = {
  frequency: frequencyPropType.isRequired,
  onFrequencyChange: PropTypes.func.isRequired,
  sprintWeeksCount: PropTypes.number.isRequired,
};

export const FrequencyDialogBody = ({
  frequency,
  onFrequencyChange,
  sprintWeeksCount,
}) => {
  const onWeekdayRadioButtonChange = () => {
    const currentWeekDayIndex = dateUtils().get('day');
    const currentWeekDay = dateUtils
      .weekDays('weekdaysShort')
      .at(currentWeekDayIndex - 1);

    if (!currentWeekDay) {
      return;
    }

    onFrequencyChange({
      type: TARGET_TYPES.WEEKDAY,
      weekday: {
        ...WEEKDAY_TARGET_DEFAULT,
        [currentWeekDay.toLowerCase()]: true,
      },
    });
  };

  const onCustomWeeklyRadioButtonChange = () => {
    onFrequencyChange({
      type: 'custom',
      weekly: new Array(sprintWeeksCount).fill(getWeeklyValue(frequency)),
    });
  };

  const onWeeklyRadioButtonChange = () => {
    onFrequencyChange({
      type: TARGET_TYPES.WEEKLY,
      weekly: getWeeklyValue(frequency),
    });
  };

  return (
    <Flex flexDirection="column" alignItems="start">
      <RadioGroup
        onValueChange={({ value }) => {
          if (value === TARGET_TYPES.WEEKDAY) {
            onWeekdayRadioButtonChange();
          } else if (value === TARGET_TYPES.WEEKLY) {
            onWeeklyRadioButtonChange();
          } else if (value === 'custom') {
            onCustomWeeklyRadioButtonChange();
          }
        }}
        value={frequency.type}
      >
        <ChallengeFrequencyDialogWeekdayField
          frequency={frequency}
          onFrequencyChange={onFrequencyChange}
        />
        <ChallengeFrequencyDialogNumberWeeklyField
          frequency={frequency}
          onFrequencyChange={onFrequencyChange}
        />
        <ChallengeFrequencyDialogCustomWeeklyField
          frequency={frequency}
          onFrequencyChange={onFrequencyChange}
          sprintWeeksCount={sprintWeeksCount}
        />
      </RadioGroup>
    </Flex>
  );
};

FrequencyDialogBody.propTypes = FrequencyDialogBodyPropTypes;

const getWeeklyValue = (frequency) => {
  switch (frequency.type) {
    case TARGET_TYPES.WEEKLY:
      return frequency.weekly;
    case TARGET_TYPES.WEEKDAY:
      return Object.values(frequency.weekday).reduce(
        (acc, curr) => acc + Number(curr),
        0
      );
    case 'custom':
      // For custom type, if all values are the same, return that value
      // Otherwise return the first non-zero value or 1
      if (Array.isArray(frequency.weekly)) {
        const uniqueValues = [...new Set(frequency.weekly)];
        if (uniqueValues.length === 1) {
          return uniqueValues[0];
        }
        return frequency.weekly.find((val) => val > 0) || 1;
      }
      return 1;
    default:
      return 1;
  }
};
